import React, { useContext, useEffect, useRef, useState } from 'react';
import { debounce } from 'debounce';

import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import AuthContext from '../../../services/firebase/AuthContext';
import FireDataContext from '../../../services/firebase/FireDataContext';
import makeFilters from '../../../app/common/RegexFilters';
import MemberMiniMenu from '../menus/MemberMiniMenu';
import Spacer from '../../../app/common/ui/Spacer';

const UserDirectoryPage = () => {
    const { currentUser } = useContext(AuthContext);
    const db = useContext(FireDataContext);
    const [users, setUsers] = useState([]);
    const [orgs, setOrgs] = useState([]);
    const queryRef = useRef();
    const [query, setQuery] = useState(makeFilters(undefined))

    useEffect(() => {
        const unsubscribe = db.subscribe({
            path: `users`,
            hook: data => {
                setUsers(data);
            }
        })

        db.get({ path: 'organizations' })
            .then(data => {
                setOrgs(data);
            })

        return unsubscribe;
    }, [db]);

    if (!currentUser.roles?.includes('admin') && !currentUser.roles?.includes('superuser')) return <></>;

    if (!users?.length) return <></>;

    const handleSearchChange = debounce(() => setQuery(makeFilters(queryRef.current?.value)), 300);

    // const removeAdminRights = user => {
    //     db.update({
    //         path: `users/${user.id}`,
    //         payload: {
    //             roles: user.roles.filter(role => role !== 'admin')
    //         },
    //         context: '5e4194d6-7da0-429c-a6d7-c88f52ce5c4a'
    //     });
    // }

    return (
        <MemberMiniMenu>
            <div>
                <Typography variant="h6" color="initial">All Users</Typography>
                <TextField
                    id="query"
                    label="Search"
                    inputRef={queryRef}
                    onChange={handleSearchChange}
                />
                <Spacer space='2rem' />

                <div style={{ fontWeight: 'bold' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={2}>User Name</Grid>
                        <Grid item xs={3}>Organisation</Grid>
                        <Grid item xs={2}>Email</Grid>
                        <Grid item xs={2}>Roles</Grid>
                        <Grid item xs={1}>ID</Grid>
                        <Grid item xs={1}>UID</Grid>
                        <Grid item xs={1}>ORG ID</Grid>
                    </Grid>

                </div>
                <Spacer />
                {
                    users?.sort((a, b) => a.name?.localeCompare(b.name))
                        .map(user => {
                            const { name: orgName = '' } = orgs.find(o => o.id === user.organization) || {};
                            return { ...user, orgName };
                        })
                        .filter(({ orgName = '', name = '', email = '', roles = [] }) => query.every(rx => rx.test(JSON.stringify({
                            orgName,
                            name,
                            email,
                            roles
                        }))))
                        .map(user => {

                            const {
                                id = '',
                                uid = '',
                                name = '',
                                email = '',
                                roles = [],
                                orgName = '',
                                organization = '',
                                xeroContactId = ''
                            } = user;

                            return (
                                <div key={id}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={2}> {roles.includes('member') ? <a href={`/members/${uid}`}>{name}</a> : name}</Grid>
                                        <Grid item xs={2}>{xeroContactId}</Grid>
                                        <Grid item xs={3}>{roles.includes('customer') ? <a href={`/admin/organization/${organization}`}>{orgName}</a> : orgName}</Grid>
                                        <Grid item xs={2}>{email}</Grid>
                                        <Grid item xs={2}>
                                            {
                                                // roles.includes('admin') ?
                                                // <Button variant="contained" color="secondary" size="small" onClick={() => removeAdminRights(user)}>
                                                //     {roles.join(', ')}
                                                // </Button>
                                                // :
                                                <span>{roles.join(', ')}</span>
                                            }
                                        </Grid>

                                        <Grid item xs={1}>{id.replace(/0000000000/, '').slice(0, 6)}</Grid>
                                        <Grid item xs={1}>{uid.slice(0, 4)}</Grid>
                                        <Grid item xs={1}>{organization.slice(0, 4)}</Grid>
                                    </Grid>
                                    <Divider />
                                    <Spacer />
                                </div>
                            )
                        })
                }
            </div>
        </MemberMiniMenu>
    );
};

const UserDirectoryPagePath = 'admin/users';

export default UserDirectoryPage;

export {
    UserDirectoryPagePath
}